var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThief(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3D5E0"
    },
    d: "M496.2,248.1C496.2,111.1,385.1,0,248.1,0S0,111.1,0,248.1s111.1,248.1,248.1,248.1 S496.2,385.1,496.2,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D0F0F"
    },
    d: "M248.1,496.2c70.2,0,133.6-29.2,178.7-76c-2.8-15.1-5.6-28.9-8.3-37.4 c-8.5-27.3-81.2-49.3-170.8-49.3s-161.5,22-170,49.3c-2.6,8.5-5.5,22.2-8.3,37.4C114.5,467,177.9,496.2,248.1,496.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#172023"
    },
    d: "M353.1,311.1c-24.6-20.7-70.9,5-104.9,5s-80.3-25.7-104.9-5c-16,13.4-14,52.7,23.5,63.5 c58.1,16.8,79.5,25.2,81.4,25.9v0.1c0,0,0,0,0.1,0h0.1v-0.1c1.9-0.7,23.2-9.2,81.4-25.9C367.1,363.8,369.1,324.5,353.1,311.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M287,282.1h-77.8c12.1,36.6,1,53.3,1,53.3s11.9,13.2,37.9,13.2s37.9-13.2,37.9-13.2 S274.9,318.7,287,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M336.4,175.2c0-92.4-39.5-113.6-88.3-113.6c-48.7,0-88.3,21.2-88.3,113.6c0,31.3,6.2,55.8,15.5,74.7 c20.4,41.6,55.7,56.1,72.8,56.1s52.4-14.5,72.8-56.1C330.2,231,336.4,206.5,336.4,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC8A68"
    },
    d: "M336.4,175.2c0,0-15.9,56.2-44,56.2c-24.8,0-34-9.3-44.3-9.3s-19.5,9.3-44.3,9.3 c-24.7,0-44-56.2-44-56.2c0,31.3,6.2,55.8,15.5,74.7c20.4,41.6,55.7,56.1,72.8,56.1s52.4-14.5,72.8-56.1 C330.2,231,336.4,206.5,336.4,175.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M170.4,238.7c-8.4,1.4-14.4,0.1-19.1-27.7s1.7-31.5,10.1-32.9L170.4,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M325.9,238.7c8.4,1.4,14.3,0.1,19.1-27.7c4.8-27.8-1.7-31.5-10.1-32.9L325.9,238.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47200D"
    },
    d: "M336.4,175.2c0-92.4-30.3-116.1-88.3-116.1s-88.3,23.7-88.3,116.1c0,0,16.3-34.1,28.3-53.1 s38-18.3,38-18.3h49c0,0,27,0.3,34.5,18.3L336.4,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47200D"
    },
    d: "M165.5,140.8c-4.2,10.9-5.6,24.4-5.6,37.5c0,0,8.8-1.9,8.8,2.6l2.8,27.6l3.9-1.9 c-0.2-23,4.9-83.5,4.9-83.5L165.5,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47200D"
    },
    d: "M330.8,140.8c4.2,10.9,5.6,24.4,5.6,37.5c0,0-8.8-1.9-8.8,2.6l-2.8,27.6l-3.9-1.9 c0.2-23-4.9-81.7-4.9-81.7L330.8,140.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2D2D"
    },
    d: "M336.8,193.3c0,0-30,31-52.7,31s-23.5-10.2-36-10.2s-13.8,10.2-35.2,10.2s-53.5-31-53.5-31v-14h177.5 v14H336.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F4B382"
    },
    cx: 278,
    cy: 200.4,
    rx: 17.7,
    ry: 12.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F4B382"
    },
    cx: 218.2,
    cy: 200.4,
    rx: 17.7,
    ry: 12.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M341.4,166.8c0-90.5-41.8-111.3-93.3-111.3s-93.3,20.7-93.3,111.3H341.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#3A3A3A"
    },
    cx: 248.1,
    cy: 56.4,
    rx: 12.8,
    ry: 8.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949"
    },
    d: "M209.5,156c-0.9,0-1.5-0.7-1.5-1.5c0-48,7.2-76.6,22-87.6c0.7-0.5,1.6-0.4,2.2,0.3 c0.5,0.7,0.4,1.6-0.3,2.2c-14,10.4-20.7,38.2-20.7,85.1C211.1,155.3,210.4,156,209.5,156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949"
    },
    d: "M286.7,156c-0.9,0-1.5-0.7-1.5-1.5c0-46.9-6.8-74.8-20.7-85.1c-0.7-0.5-0.8-1.5-0.3-2.2 s1.5-0.8,2.2-0.3c14.8,11,22,39.7,22,87.6C288.2,155.3,287.5,156,286.7,156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949"
    },
    d: "M248.1,130.3c-0.9,0-1.5-0.7-1.5-1.5V64.1c0-0.9,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v64.7 C249.6,129.6,249,130.3,248.1,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949"
    },
    d: "M321.4,156.4c-0.9,0-1.5-0.7-1.5-1.5c0-47-13.1-75-40-85.4c-0.8-0.3-1.2-1.2-0.9-2 c0.3-0.8,1.2-1.2,2-0.9c28.2,10.9,41.9,39.8,41.9,88.2C322.9,155.7,322.2,156.4,321.4,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494949"
    },
    d: "M174.8,156.4c-0.9,0-1.5-0.7-1.5-1.5c0-48.5,13.7-77.3,41.9-88.2c0.8-0.3,1.7,0.1,2,0.9 s-0.1,1.7-0.9,2c-26.9,10.4-40,38.3-40,85.4C176.4,155.7,175.7,156.4,174.8,156.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2D2D"
    },
    d: "M354.3,173.9c0,6.4-5.2,11.6-11.6,11.6c0,0-38.2-15.5-94.7-15.5s-94.7,15.5-94.7,15.5 c-6.4,0-11.6-5.2-11.6-11.6v-23c0-6.4,5.2-11.6,11.6-11.6c0,0,48.2-15.5,94.7-15.5s94.7,15.5,94.7,15.5c6.4,0,11.6,5.2,11.6,11.6 V173.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M157.6,177.1c-0.8,0-1.5-0.7-1.5-1.5v-28.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v28.5 C159.1,176.4,158.4,177.1,157.6,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M173.1,173.8c-0.8,0-1.5-0.7-1.5-1.5v-28.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v28.5 C174.6,173.1,173.9,173.8,173.1,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M192.2,169.8c-0.8,0-1.5-0.7-1.5-1.5v-28.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v28.5 C193.7,169.1,193,169.8,192.2,169.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M211.2,166.4c-0.8,0-1.5-0.7-1.5-1.5v-28.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v28.5 C212.7,165.8,212,166.4,211.2,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M230.3,164.4c-0.8,0-1.5-0.7-1.5-1.5v-28.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v28.5 C231.8,163.8,231.1,164.4,230.3,164.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M248.1,164.3c-0.8,0-1.5-0.7-1.5-1.5v-28.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v28.5 C249.6,163.6,248.9,164.3,248.1,164.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M338.7,177.1c0.8,0,1.5-0.7,1.5-1.5v-28.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v28.5 C337.2,176.4,337.9,177.1,338.7,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M323.2,173.8c0.8,0,1.5-0.7,1.5-1.5v-28.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v28.5 C321.7,173.1,322.4,173.8,323.2,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M304.1,169.8c0.8,0,1.5-0.7,1.5-1.5v-28.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v28.5 C302.6,169.1,303.3,169.8,304.1,169.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M285.1,166.4c0.8,0,1.5-0.7,1.5-1.5v-28.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v28.5 C283.6,165.8,284.2,166.4,285.1,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3A3A"
    },
    d: "M266,164.4c0.8,0,1.5-0.7,1.5-1.5v-28.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v28.5 C264.5,163.8,265.2,164.4,266,164.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.5,337.4L311.5,337.4L311.5,337.4L311.5,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.5,335.9L298.5,335.9L298.5,335.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThief);
export default __webpack_public_path__ + "static/media/thief.d8209fedc3d4ae4e7d7e069aca45153a.svg";
export { ForwardRef as ReactComponent };